var moduleMap = {
	"AuthSource": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_cross-fetch_dist_browser-ponyfill_js-node_modules_graphql-tag_lib_index_-9fa6fc"), __webpack_require__.e("src_exports_AuthSource_AuthSource_ts")]).then(() => (() => ((__webpack_require__(387)))));
	},
	"SearchInput": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_cross-fetch_dist_browser-ponyfill_js-node_modules_graphql-tag_lib_index_-9fa6fc"), __webpack_require__.e("vendors-node_modules_mui_icons-material_Apartment_js-node_modules_mui_icons-material_HeadsetM-40ba51"), __webpack_require__.e("src_exports_SearchInput_SearchInput_tsx")]).then(() => (() => ((__webpack_require__(3556)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});